import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Sparkles, Loader2 } from "lucide-react";

const TONES = ["Balanced", "Conservative", "Aggressive", "Investor-Ready", "Technical"];

export const RegenerateDialog = ({ open, onOpenChange, title, onSubmit, loading }) => {
  const [tone, setTone] = useState("Balanced");
  const [instructions, setInstructions] = useState("");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-700" data-testid="regenerate-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Regenerate: {title}</DialogTitle>
          <DialogDescription>AI will rewrite this section. Your other sections stay untouched.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-2">
          {TONES.map((t) => (
            <button key={t} data-testid={`tone-${t.toLowerCase()}`} onClick={() => setTone(t)}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${tone === t ? "bg-emerald-500 text-emerald-950 border-emerald-500" : "border-slate-700 text-slate-300 hover:border-slate-500"}`}>{t}</button>
          ))}
        </div>
        <Textarea data-testid="regenerate-instructions" value={instructions} onChange={(e) => setInstructions(e.target.value)}
          placeholder="Optional: e.g. assume higher rent costs, focus on B2B customers…" className="bg-slate-950/60 border-slate-700" />
        <Button data-testid="regenerate-submit" disabled={loading} onClick={() => onSubmit({ tone, instructions })} className="bg-emerald-500 text-emerald-950 hover:bg-emerald-400">
          {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Sparkles className="h-4 w-4 mr-2" />}
          {loading ? "Rewriting section…" : "Regenerate with AI"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
